import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import AuthLayout from "@/components/AuthLayout";
import { t } from "@/lib/i18n";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { setError(errMsg(err)); }
    setBusy(false);
  };

  return (
    <AuthLayout title={t("Forgot password")} subtitle={t("Enter your account email and we'll send you a secure reset link.")}>
      {sent ? (
        <div className="hf-card p-6 space-y-3" data-testid="forgot-success">
          <MailCheck className="w-8 h-8 text-amber-600" />
          <p className="font-semibold">{t("Check your inbox")}</p>
          <p className="text-sm text-slate-600">{t("If an account exists for")} <b>{email}</b>{t(", a reset link is on its way. It expires in 1 hour.")}</p>
          <Link to="/login" className="hf-btn-dark w-full" data-testid="back-to-login-btn">{t("Back to login")}</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <div>
            <label className="hf-label">{t("Email")}</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="hf-input" data-testid="forgot-email-input" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="forgot-error">{error}</p>}
          <button disabled={busy} className="hf-btn-dark w-full h-12 text-base" data-testid="forgot-submit-btn">{busy ? t("Sending…") : t("Send reset link")}</button>
          <p className="text-sm text-slate-600">{t("Remembered it?")} <Link to="/login" className="text-amber-600 font-semibold">{t("Login")}</Link></p>
        </form>
      )}
    </AuthLayout>
  );
}
